module.exports = __webpack_public_path__ + "img/Antim_Ivireanul_Invatatura_bisericeasca_Targoviste_1710_foaie_de_titlu.fcda48d4.jpg";